/* @flow */
import React from 'react'
import PersistedComponent from '../PersistedComponent'
import Loader from '../../utils/Loader'
import request from '../../utils/Request'
import UTM from '../../utils/UTM'
import { API_WIDGETDATA_URI, SIGNS } from '../../../constants'
import WidgetContainer from '../../containers/WidgetContainer'
import SignText from './StyledSignText'
import SignSelect from './SignSelect'
import NameContainer from './StyledNameContainer'
import HoroscopeLink from './StyledHoroscopeLink'
import SignIcon from './StyledSignIcon'
import type { HoroscopesWidgetState } from './Types'
import { type HoroscopesWidgetProps } from './Types'

const DEFAULT_SIGN_INDEX = 0

export default class Horoscopes extends PersistedComponent<HoroscopesWidgetProps, HoroscopesWidgetState> {
  constructor (props: HoroscopesWidgetProps) {
    super(props)

    this.persistedKeys = [ 'signIndex' ]

    this.state = Object.assign({}, this.state, {
      isLoading: false,
      signIndex: DEFAULT_SIGN_INDEX
    })

    this.cachedHoroscopes = []

    this.handleSelectSignClick = this.handleSelectSignClick.bind(this)
  }

  componentWillMount () {
    super.componentWillMount()

    const {
      cachedHoroscopes,
      props: {
        widget: {
          boxes
        }
      },
      state: {
        signIndex
      }
    } = this

    const horoscope = Object.assign({}, SIGNS[signIndex], boxes[0] || {})

    this.setState({
      horoscope
    })

    cachedHoroscopes[signIndex] = horoscope
  }

  componentDidMount () {
    const {
      signIndex
    } = this.state

    if (signIndex !== DEFAULT_SIGN_INDEX) {
      this.loadSignData(signIndex)
    }
  }

  loadSignData (signIndex: number): void {
    const horoscope = this.cachedHoroscopes[signIndex]

    if (horoscope) {
      this.setState({
        horoscope,
        signIndex
      })
    } else {
      this.setState({
        isLoading: true
      })

      this.sendRequest(signIndex).then(horoscope => {
        this.setState({
          horoscope,
          isLoading: false,
          signIndex
        })
      }).catch(() => {
        this.setState({
          isLoading: false
        })
      })
    }
  }

  handleSelectSignClick: (signIndex: number) => void
  handleSelectSignClick (signIndex: number): void {
    this.loadSignData(signIndex)
  }

  sendRequest (index: number): Promise<{}> {
    const selectedSign = SIGNS[index]
    const {
      widget: {
        name
      }
    } = this.props

    const requestConfig = {
      url: `${API_WIDGETDATA_URI}?sign=${selectedSign.guid}`,
      method: 'post',
      data: {
        widgetConfig: {
          [name]: {
            name,
            boxesConfig: [
              {
                source: 'Horoscopes'
              }
            ]
          }
        }
      }
    }

    return request(requestConfig).then(response => {
      const box = response.data[name].boxes[0] || {}
      const mergedHoroscope = Object.assign({}, selectedSign, box)

      if (Object.keys(box).length > 0) {
        this.cachedHoroscopes[index] = mergedHoroscope
      }

      return mergedHoroscope
    })
  }

  render () {
    const {
      activeDynamicLayout,
      widget,
      widget: {
        meta: {
          detailLinkPattern
        },
        utmContent,
        utmMedium,
        utmSource
      }
    } = this.props
    const {
      horoscope: {
        guid,
        name,
        date,
        title,
        background
      },
      isLoading,
      signIndex
    } = this.state
    const utmParams = {
      utmContent,
      utmMedium,
      utmSource,
      utmTerm: `position-${signIndex + 1}`
    }
    const detailLink = detailLinkPattern.replace('{sign}', guid)
    const utmDetailLink = new UTM(detailLink).getUTMLink(utmParams)

    return (
      <WidgetContainer widget={widget}>
        {
          isLoading &&
          <Loader/>
        }
        <SignSelect signs={SIGNS} handleSelectSign={this.handleSelectSignClick} device={activeDynamicLayout}/>
        <HoroscopeLink href={utmDetailLink}>
          <NameContainer>
            <SignText>
              { name }
            </SignText>
            <div>
              ({ date })
            </div>
            <SignIcon backgroundPosition={background}/>
          </NameContainer>
          <div>
            { title }
          </div>
        </HoroscopeLink>
      </WidgetContainer>
    )
  }
}
